
import { useDispatch, useSelector } from "react-redux";

import { removeImageFromPath, uploadFileToServer } from "../../../components/Forms/FormHandler.jsx";
import { toast } from "react-toastify";
import ConfigQrPassUi from "./QrPassUi.jsx";
import { GET_SYSTEM_CONFIG, SET_SYSTEM_CONFIG } from "../../../../store/actions/ActionTypes.js";
import { get } from "../../../../store/actions/CommonActions.js";
import { apiCaller } from "../../../../services/AxiosInstance.js";
import { useEffect } from "react";

const ConfigQrPass = () => {
    const dispatch = useDispatch();
    const fetchData = async () => {
        const response = await apiCaller({ url: 'configs' });
        dispatch({
            type: GET_SYSTEM_CONFIG,
            payload: response?.data?.data,
        });
        if (response) {
            localStorage.setItem('systemconfigs', JSON.stringify(response?.data?.data));
        }
    }
    useEffect(() => {
        console.log('avndinveuibeves');
        fetchData();
    }, []);

    return (
        <ConfigQrPassUi
            callback={fetchData}
        />
    );
};

export default ConfigQrPass;
